import React from "react";
import {
  Col,
  Row,
  Container,
} from "reactstrap";
import DeckGL from "@deck.gl/react";
import { MapView, WebMercatorViewport, MapController } from "@deck.gl/core";
import {
  DrawPolygonMode,
  ViewMode,
  MeasureDistanceMode,
} from "nebula.gl";
import { StaticMap } from "react-map-gl";
import _ from "lodash";
import api from "../../../../api";
import Constant from "../../../../constants";
import PolygonInfoModal from "../../components/PolygonInfoModal";
import PolygonCommentModal from "../../components/PolygonCommentModal";
import SearchBox from "../../components/SearchBox";
import PolygonMapTooltip from "../../components/PolygonMapTooltip";
import NearbyLocationMapTooltip from "../../components/NearbyLocationMapTooltip";
import WardMapTooltip from "../../components/WardMapTooltip";
import ExternalRetailDemandTooltip from "../../components/ExternalRetailDemandTooltip";
import TrafficCountingPointTooltip from "../../components/TrafficCountingPointTooltip";
import "./index.css";
import MenuToggle from "pages/StorePlanning/components/Menu/MenuToggle";
import MenuActions from "pages/StorePlanning/components/Menu/MenuActions";
import RightCorner from "pages/StorePlanning/components/RightCorner";
import MapLayer from "pages/StorePlanning/components/MapLayer";

const DEFAULT_GEOJSON_DRAWING = {
  type: "FeatureCollection",
  features: [],
};
class SitePlanningMap extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/prop-types
    const { latitude, longitude, defaultMapStyle } = this.props;

    const initialViewState = {
      latitude: latitude || 10.77653,
      longitude: longitude || 106.700981,
      zoom: 15,
      pitch: 0,
      bearing: 0,
    };

    this.state = {
      gettingCurrentLocation: false,
      currentLocation: {
        latitude: latitude ? latitude : 10.77653,
        longitude: longitude ? longitude : 106.700981,
      },
      initialViewState,
      viewState: initialViewState,
      debugMode: false,
      wards: [],
      drawingGeoJson: DEFAULT_GEOJSON_DRAWING,
      planningPolygons: [],
      showPlanningPolygon: false,
      selectedFeatureIndexes: [],
      isEnableDrawing: false,
      isEnableSelection: false,
      isShowToolbar: false,
      mapMode: ViewMode,
      isShowPolygonInfoModal: false,
      mapStyle: defaultMapStyle || Constant.MAP_STYLES[0],
      mapSettings: {
        showWardBoundary: false,
        showWardDensity: false,
        showPlanningZoneTitle: false,
      },
      selectedNearbyLocationTypesToShow: [],
    };
  }
  componentDidMount = () => {
    document.title = "LISA Planning Map";
    this.getCurrentUser();
    this.getWards();
    document.addEventListener("keydown", this.escFunction, false);
  };
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }
  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.setState({
        isEnableDrawing: false,
        mapMode: ViewMode,
      });
    }
  };
  handleMapViewStateChange = _.debounce((state) => {
    const { viewState } = state;
    const viewport = new WebMercatorViewport(viewState);
    this.getMapBoundary(viewport);
    this.setState({ viewState });
  }, 500);
  changeZoomLevel = (incrementalLevel) => {
    const { initialViewState } = this.state;
    this.setState({
      initialViewState: {
        ...initialViewState,
        zoom: initialViewState.zoom + incrementalLevel,
      },
    });
  };
  toggleMeasureMode = () => {
    const { mapMode } = this.state;
    this.setState({
      mapMode: mapMode === MeasureDistanceMode ? ViewMode : MeasureDistanceMode,
    });
  };
  toggleSitePlanningCommentUI = (planningPolygon) => {
    const { isShowCommentPopup } = this.state;
    this.setState({
      isShowCommentPopup: !isShowCommentPopup,
      planningPolygonToShowComment: planningPolygon,
    });
  };
  toggleMapToolbar = () => {
    const { isShowToolbar } = this.state;
    this.setState({
      isShowToolbar: !isShowToolbar,
    });
  };
  toggleDrawingMode = () => {
    const { isEnableDrawing } = this.state;
    this.setState({
      isEnableDrawing: !isEnableDrawing,
      mapMode: isEnableDrawing ? ViewMode : DrawPolygonMode,
    });
  };
  toggleSelectionMode = () => {
    const { isEnableSelection } = this.state;
    this.setState({
      isEnableSelection: !isEnableSelection,
      selectedFeatureIndexes: [],
    });
  };
  setShowTrafficCounting = (isShow) => {
    this.setState({ isShowTrafficCounting: isShow });
  };
  setMapSettings = (attributeName, value) => {
    const { mapSettings } = this.state;
    mapSettings[attributeName] = value;
    this.setState({
      mapSettings,
    });
  };
  navigateToLocation(location) {
    const newViewState = {
      latitude: location.lat,
      longitude: location.lng,
      zoom: 16.5,
      pitch: 0,
      bearing: 0,
    };
    this.setState({
      viewState: newViewState,
      gettingCurrentLocation: false,
      currentLocation: {
        latitude: location.lat,
        longitude: location.lng,
      },
    });
  }
  goToSelectedLocation(selectedItem) {
    if (selectedItem?.geometry?.location) {
      const selectedItemLocation = selectedItem?.geometry?.location;
      this.navigateToLocation(selectedItemLocation);
    }
  }
  getCurrentUser() {
    api.fetchAPI({
      method: "get",
      uri: `userme/me?include_permissions=planning_map`,
      success: (response) => {
        if (response.result) {
          this.setState({
            currentUser: response.result,
          });
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  checkUserPermissions(permissionGroupName, permissionName) {
    const { currentUser } = this.state;
    if (!currentUser) return false;
    if (!currentUser.permissions.planning_map[permissionGroupName])
      return false;
    return currentUser.permissions.planning_map[permissionGroupName].includes(
      permissionName
    );
  }
  getLocationTypes() {
    api.fetchAPI({
      method: "get",
      uri: `location_type/`,
      success: (response) => {
        const filterLocationTypeIds = [];
        response.result.map((locationType) =>
          filterLocationTypeIds.push(locationType.id)
        );
        this.setState({
          locationTypes: response.result,
          filterLocationTypeIds,
        });
      },
      error: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  }
  getExternalFoodAndBeverageData() {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalFoodAndBeverageDataModelApi",
        "can_get_external_fnb_data_by_boundary"
      )
    )
      return;
    this.setState({ isGetExternalFoodAndBeverageData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_food_and_beverage_data/by_boundary`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            foodAndBeverageDemand: response.food_and_beverage_demand,
            isGetExternalFoodAndBeverageData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetExternalFoodAndBeverageData: false });
      },
    });
  }
  getExternalFoodAndBeverageCategories() {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalFoodAndBeverageDataModelApi",
        "can_get_external_fnb_data_by_category_boundary"
      )
    )
      return;
    this.setState({ isGetExternalFoodAndBeverageData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_food_and_beverage_data/by_boundary/category`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            foodAndBeverageCategoryDemand: response,
            isGetExternalFoodAndBeverageData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetExternalFoodAndBeverageData: false });
      },
    });
  }
  getExternalFoodAndBeveragePoints = () => {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalFoodAndBeverageDataModelApi",
        "can_list_with_condition"
      )
    )
      return;
    this.setState({ isGetExternalFoodAndBeverageData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_food_and_beverage_data/by_boundary/list`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            foodAndBeverageTransactions:
              response.food_and_beverage_transactions,
            isGetExternalFoodAndBeverageData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetExternalFoodAndBeverageData: false });
      },
    });
  };
  getExternalRetailData() {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalRetailDataModelApi",
        "can_get_external_retail_data_by_boundary"
      )
    )
      return;
    this.setState({ isGetExternalRetailData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_retail_data/by_boundary`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            externalRetailDemand: response,
            isGetExternalRetailData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetExternalRetailData: false });
      },
    });
  }
  getExternalRetailDataDetail = () => {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalRetailDataModelApi",
        "can_get_external_retail_data_detail_by_boundary"
      )
    )
      return;
    this.setState({ isGetExternalRetailData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_retail_data/by_boundary/list`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            externalRetailDemandDetail: response.retail_demand,
            isGetExternalRetailData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetExternalRetailData: false });
      },
    });
  };
  getExternalFoodAndBeverageDeliveryData = () => {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalFoodAndBeverageDeliveryDataModelApi",
        "can_get_external_fnb_delivery_data_by_boundary"
      )
    )
      return;
    this.setState({ isGetExternalFoodAndBeverageDeliveryData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_food_and_beverage_delivery_data/by_boundary`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            foodAndBeverageDeliveryDemand:
              response.food_and_beverage_delivery_demand,
            isGetExternalFoodAndBeverageDeliveryData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetExternalFoodAndBeverageDeliveryData: false });
      },
    });
  };
  getExternalFoodAndBeverageDeliveryPoints = () => {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalFoodAndBeverageDeliveryDataModelApi",
        "can_list_with_condition"
      )
    )
      return;
    this.setState({ isGetExternalFoodAndBeverageDeliveryData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_food_and_beverage_delivery_data/by_boundary/list`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            foodAndBeverageDeliveryTransactions:
              response.food_and_beverage_delivery_transactions,
            isGetExternalFoodAndBeverageDeliveryData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetExternalFoodAndBeverageDeliveryData: false });
      },
    });
  };
  getStaticDemandData = () => {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalDropOffLocationDataModelApi",
        "can_get_external_drop_off_location_data_by_boundary"
      )
    )
      return;
    if (!mapBoundary) return null;
    this.setState({ isGetStaticDemandData: true });
    api.fetchAPI({
      method: "post",
      uri: `external_static_demand_data/by_boundary`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            staticDemand: response.static_demand,
            isGetStaticDemandData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetStaticDemandData: false });
      },
    });
  };
  getStaticDemandPoints() {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "ExternalDropOffLocationDataModelApi",
        "can_list_with_condition"
      )
    )
      return;
    this.setState({ isGetStaticDemandData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `external_static_demand_data/by_boundary/list`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            staticDemandTransactions: response.static_demand_transactions,
            isGetStaticDemandData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetStaticDemandData: false });
      },
    });
  }
  getNearbyLocationSummary() {
    const { mapBoundary } = this.state;
    if (
      !this.checkUserPermissions(
        "LocationModelApi",
        "can_get_location_type_group_by_boundary"
      )
    )
      return;
    this.setState({ isGetNearbyLocationSummary: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `location/by_boundary/group_by/location_type`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            nearbyLocationTypeSummary: response.result,
            isGetNearbyLocationSummary: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetNearbyLocationSummary: false });
      },
    });
  }
  getWards() {
    const { mapBoundary } = this.state;
    if (!mapBoundary) return null;
    this.setState({ isGetWardsDemographics: true });
    api.fetchAPI({
      method: "post",
      uri: `ward/by_boundary`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState(
            {
              wards: response.wards,
              isGetWardsDemographics: false,
            },
            this.getWardsDemographics
          );
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetWardsDemographics: false });
      },
    });
  }
  getWardsDemographics() {
    const { wards } = this.state;
    const wardIds = wards.map((ward) => ward.id) || [];
    if (wardIds.length <= 0) return;
    const requestBody = {
      wards: wardIds,
    };
    this.setState({ isGetWardsDemographics: true });
    api.fetchAPI({
      method: "post",
      uri: `ward/demographics`,
      body: requestBody,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            summaryData: response.summary,
            isGetWardsDemographics: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetWardsDemographics: false });
      },
    });
  }
  getTrafficCountingData() {
    const { mapBoundary } = this.state;
    this.setState({ isGetTrafficCountingData: true });
    if (!mapBoundary) return null;
    api.fetchAPI({
      method: "post",
      uri: `traffic_scan_period/by_boundary`,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            trafficCountingData: response.result,
            isGetTrafficCountingData: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetTrafficCountingData: false });
      },
    });
  }
  getMapBoundary(viewport) {
    const nw = viewport.unproject([0, 0]);
    const se = viewport.unproject([viewport.width, viewport.height]);
    const ne = viewport.unproject([viewport.width, 0]);
    const sw = viewport.unproject([0, viewport.height]);
    const mapBoundary = {
      nw,
      ne,
      se,
      sw,
    };
    const mapBoundaryGeoJson = {
      geometry: {
        coordinates: [[nw, ne, se, sw, nw]],
        type: "Polygon",
      },
      properties: {
        name: "XXX",
      },
      type: "Feature",
    };
    this.setState({ mapBoundary, mapBoundaryGeoJson }, () => {
      this.getWards();
      this.getExternalFoodAndBeverageCategories();
      this.getExternalFoodAndBeverageData();
      this.getExternalFoodAndBeverageDeliveryData();
      this.getStaticDemandData();
      this.getNearbyLocationSummary();
      this.getNearbyLocationDetail();
      this.getSitePlanningPolygon();
      this.getExternalRetailData();
      // this.getTrafficCountingData();
    });
  }
  toggleShowPlanningPolygons = () => {
    const { showPlanningPolygon, selectedFeatureIndexes } = this.state;
    const newShowPlanningPolygon = !showPlanningPolygon;

    let newSelectedFeatureIndexes = selectedFeatureIndexes;
    if (!newShowPlanningPolygon) {
      newSelectedFeatureIndexes = [];
    }
    this.setState(
      {
        showPlanningPolygon: newShowPlanningPolygon,
        selectedFeatureIndexes: newSelectedFeatureIndexes,
      },
      () => {
        if (newShowPlanningPolygon) {
          this.getSitePlanningPolygon();
        }
      }
    );
  };
  toggleShowMyBrandStore() {
    const { showMyBrandStore } = this.state;
    let newShowMyBrandStore = !showMyBrandStore;
    this.setState(
      {
        showMyBrandStore: newShowMyBrandStore,
      },
      () => this.showMyBrandStore()
    );
  }
  showMyBrandStore() {
    const { showMyBrandStore } = this.state;
    if (!showMyBrandStore) {
      this.setState({
        currentUserBrandSites: [],
        showMyBrandStore: false,
      });
      return;
    }
    api.fetchAPI({
      method: "get",
      uri: `site/list?limit=1000`,
      success: (response) => {
        if (response.result) {
          this.setState({ currentUserBrandSites: response.result });
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  getSitePlanningPolygon() {
    const { mapBoundary, showPlanningPolygon } = this.state;
    if (!showPlanningPolygon) return;
    const uri = `site_planning_selection_area/list?limit=10000`;
    api.fetchAPI({
      method: "post",
      uri,
      body: mapBoundary,
      success: (response) => {
        if (response.status === "ok") {
          const planningPolygonsTransformed = response.result.map(
            (planningPolygon) => {
              // We need to prepare the GeoJSON format
              // And add polygon attribute to the GeoJSON itself
              const newPlanningPolygon = planningPolygon;
              const newPlanningPolygonGeoJson = JSON.parse(
                newPlanningPolygon.geojson
              );
              newPlanningPolygonGeoJson.features[0].properties = planningPolygon;
              return {
                ...newPlanningPolygonGeoJson,
                properties: planningPolygon,
              };
            }
          );
          this.setState({
            planningPolygons: planningPolygonsTransformed,
            showPlanningPolygon: true,
          });
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  getNearbyLocationDetail() {
    const { mapBoundary, selectedNearbyLocationTypesToShow } = this.state;
    this.setState({ isGetNearbyLocationSummary: true });
    if (selectedNearbyLocationTypesToShow.length === 0) {
      this.setState({
        nearbyLocations: [],
        isGetNearbyLocationSummary: false,
      });
    }
    if (!mapBoundary || selectedNearbyLocationTypesToShow.length <= 0)
      return null;
    api.fetchAPI({
      method: "post",
      uri: `location/by_boundary/list`,
      body: {
        ...mapBoundary,
        location_type_id_list: selectedNearbyLocationTypesToShow.map(
          (locationType) => locationType.location_type_id
        ),
      },
      success: (response) => {
        if (response.status === "ok") {
          this.setState({
            nearbyLocations: response.result.locations,
            isGetNearbyLocationSummary: false,
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.setState({ isGetNearbyLocationSummary: false });
      },
    });
  }
  mapDrawingEditHandler = ({ updatedData, editType }) => {
    console.log("editType", editType);
    this.setState({ drawingGeoJson: updatedData });

    // On finish drawing
    // Display popup to enter information
    if (editType === "addFeature") {
      this.setState({ isShowPolygonInfoModal: true });
    }
  };
  onPolygonSaved() {
    this.setState(
      {
        drawingGeoJson: DEFAULT_GEOJSON_DRAWING,
        isShowPolygonInfoModal: false,
        planningPolygonToEdit: null,
      },
      this.getSitePlanningPolygon
    );
  }
  onPlanningPolygonItemHover = ({ object, x, y }) => {
    this.setState({
      planningPolygonHoveredObject: object,
      pointerX: x,
      pointerY: y,
    });
  };
  onNearbyLocationItemClick = ({ object, x, y }) => {
    let baseUrl = `/market_information/${object.id}`;
    if (object.site_id && !object.store_id) {
      baseUrl = `/sitev2/${object.site_id}`;
    }
    if (object.site_id && object.store_id) {
      baseUrl = `/store/${object.store_id}`;
    }
    window.open(
      baseUrl,
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  onNearbyLocationItemHover = ({ object, x, y }) => {
    this.setState({
      nearbyLocationHoveredObject: object,
      pointerX: x,
      pointerY: y,
    });
  };
  setSelectedFeatureIndexes = ({ pickingInfos }) => {
    this.setState({ selectedFeatureIndexes: pickingInfos });
  };
  onWardItemHover = ({ object, x, y }) => {
    this.setState({
      wardHoveredObject: object,
      pointerX: x,
      pointerY: y,
    });
  };
  onExternalRetailDemandItemHover = ({ object, x, y }) => {
    this.setState({
      externalRetailDemandHoveredObject: object,
      pointerX: x,
      pointerY: y,
    });
  };
  onPlanningPolygonItemClick = (selectedFeatureIndex) => {
    this.setState({
      selectedFeatureIndexes: [selectedFeatureIndex],
    });
  };
  onTrafficCountingPointHover = ({ object, x, y }) => {
    this.setState({
      trafficCountingPointHoveredObject: object,
      pointerX: x,
      pointerY: y,
    });
  };
  editPlanningPolygon = (planningPolygon) => {
    this.setState({
      isShowPolygonInfoModal: true,
      planningPolygonToEdit: planningPolygon,
    });
  };
  nearbyLocationTypeSelection = (dataToCallback) => {
    const { selectedNearbyLocationTypesToShow } = this.state;

    let newSelectedLocationTypes = selectedNearbyLocationTypesToShow || [];
    if (dataToCallback.checkStatus) {
      newSelectedLocationTypes.push(dataToCallback.selectedItem);
    } else {
      newSelectedLocationTypes = newSelectedLocationTypes.filter(
        (locationType) =>
          locationType.location_type_id !==
          dataToCallback?.selectedItem?.location_type_id
      );
    }
    this.setState(
      {
        selectedNearbyLocationTypesToShow: newSelectedLocationTypes,
      },
      this.getNearbyLocationDetail
    );
  };
  _renderPolygonMapTooltip() {
    const { planningPolygonHoveredObject, pointerX, pointerY } =
      this.state || {};
    return (
      planningPolygonHoveredObject && (
        <PolygonMapTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={planningPolygonHoveredObject.properties}
        />
      )
    );
  }
  _renderNearbyLocationMapTooltipOnClick() {
    const { nearbyLocationClickedObject, clickPointerX, clickPointerY } =
      this.state || {};
    return (
      nearbyLocationClickedObject && (
        <NearbyLocationMapTooltip
          pointerX={clickPointerX}
          pointerY={clickPointerY}
          objectToDisplay={nearbyLocationClickedObject}
          onCloseButtonClick={() =>
            this.setState({
              clickPointerX: null,
              clickPointerY: null,
              nearbyLocationClickedObject: null,
            })
          }
        />
      )
    );
  }
  _renderNearbyLocationMapTooltip() {
    const { nearbyLocationHoveredObject, pointerX, pointerY } =
      this.state || {};
    return (
      nearbyLocationHoveredObject && (
        <NearbyLocationMapTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={nearbyLocationHoveredObject}
        />
      )
    );
  }
  _renderWardMapTooltip() {
    const { wardHoveredObject, pointerX, pointerY } = this.state || {};
    return (
      wardHoveredObject && (
        <WardMapTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={wardHoveredObject}
        />
      )
    );
  }
  _renderExternalRetailDemandTooltip() {
    const { externalRetailDemandHoveredObject, pointerX, pointerY } =
      this.state || {};
    return (
      externalRetailDemandHoveredObject && (
        <ExternalRetailDemandTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={externalRetailDemandHoveredObject}
        />
      )
    );
  }
  _renderTrafficCountingPointTooltip() {
    const { trafficCountingPointHoveredObject, pointerX, pointerY } =
      this.state || {};
    return (
      trafficCountingPointHoveredObject && (
        <TrafficCountingPointTooltip
          pointerX={pointerX}
          pointerY={pointerY}
          objectToDisplay={trafficCountingPointHoveredObject}
        />
      )
    );
  }
  _getCurrentPosition = () => {
    this.setState({ gettingCurrentLocation: true });
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.navigateToLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (err) => alert("Error code " + err.code + ": " + err.message)
    );
  };
  render() {
    const {
      isShowToolbar,
      isEnableDrawing,
      isEnableSelection,
      mapMode,
      isShowPolygonInfoModal,
      mapStyle,
      drawingGeoJson,
      planningPolygonToEdit,
      isShowCommentPopup,
      planningPolygonToShowComment,
      gettingCurrentLocation,
      initialViewState,
    } = this.state;

    const { embedMode, showNearbyLocationFirst } = this.props;
    return (
      <div
        className={`site-planning__page-container ${
          embedMode ? "site-planning__embed-mode" : ""
        }`}
      >
        <Container fluid>
          <Row>
            <Col xs={12} sm={8} md={9} className="site-planning__section">
              <div
                className={`site-planning__map-container ${
                  embedMode ? "site-planning__embed-mode" : ""
                }`}
              >
                <DeckGL
                  initialViewState={initialViewState}
                  onViewStateChange={this.handleMapViewStateChange}
                  layers={MapLayer({
                    mapDrawingEditHandler: this.mapDrawingEditHandler,
                    state: this.state,
                    onExternalRetailDemandItemHover: this
                      .onExternalRetailDemandItemHover,
                    onNearbyLocationItemClick: this.onNearbyLocationItemClick,
                    onNearbyLocationItemHover: this.onNearbyLocationItemHover,
                    onPlanningPolygonItemClick: this.onPlanningPolygonItemClick,
                    onPlanningPolygonItemHover: this.onPlanningPolygonItemHover,
                    onTrafficCountingPointHover: this
                      .onTrafficCountingPointHover,
                    onWardItemHover: this.onWardItemHover,
                    setSelectedFeatureIndexes: this.setSelectedFeatureIndexes,
                  })}
                  views={[
                    new MapView({
                      id: "basemap",
                      controller: {
                        type: MapController,
                        doubleClickZoom: false,
                      },
                    }),
                  ]}
                >
                  <StaticMap
                    mapStyle={`mapbox://styles/mapbox/${mapStyle.styleCode}`}
                    mapboxApiAccessToken={Constant.MAPBOX_API_ACCESS_TOKEN}
                  />
                </DeckGL>
                {this._renderPolygonMapTooltip()}
                {this._renderNearbyLocationMapTooltip()}
                {this._renderNearbyLocationMapTooltipOnClick()}
                {this._renderWardMapTooltip()}
                {this._renderExternalRetailDemandTooltip()}
                {this._renderTrafficCountingPointTooltip()}
                <div className="site-planning__map-search-box">
                  <SearchBox
                    onItemClick={(searchResultItem) =>
                      this.goToSelectedLocation(searchResultItem)
                    }
                  />
                </div>
                {!isShowToolbar && (
                  <MenuActions
                    getCurrentPosition={this._getCurrentPosition}
                    gettingCurrentLocation={gettingCurrentLocation}
                    isEnableDrawing={isEnableDrawing}
                    isEnableSelection={isEnableSelection}
                    mapMode={mapMode}
                    toggleDrawingMode={this.toggleDrawingMode}
                    toggleMapToolbar={this.toggleMapToolbar}
                    toggleMeasureMode={this.toggleMeasureMode}
                    toggleSelectionMode={this.toggleSelectionMode}
                  />
                )}
                {isShowToolbar && (
                  <MenuToggle
                    isEnableSelection={isEnableSelection}
                    selectMapStyle={(mapStyle) => this.setState({ mapStyle })}
                    setEnableSelection={(isEnable) =>
                      this.setState({
                        isEnableSelection: isEnable,
                      })
                    }
                    toggleMapToolbar={this.toggleMapToolbar}
                  />
                )}
                <div className="site-planning__map-toolbar zoom">
                  <button
                    className="site-planning__map__zoom-button"
                    onClick={() => this.changeZoomLevel(0.5)}
                  >
                    +
                  </button>
                  <button
                    className="site-planning__map__zoom-button"
                    onClick={() => this.changeZoomLevel(-0.5)}
                  >
                    -
                  </button>
                </div>
              </div>
            </Col>
            <RightCorner
              state={this.state}
              getExternalFoodAndBeverageDeliveryPoints={
                this.getExternalFoodAndBeverageDeliveryPoints
              }
              getExternalFoodAndBeveragePoints={
                this.getExternalFoodAndBeveragePoints
              }
              getExternalRetailDataDetail={this.getExternalRetailDataDetail}
              getStaticDemandPoints={this.getStaticDemandData}
              nearbyLocationTypeSelection={this.nearbyLocationTypeSelection}
              setMapSettings={this.setMapSettings}
              setShowTrafficCounting={this.setShowTrafficCounting}
              showNearbyLocationFirst={showNearbyLocationFirst}
              embedMode={embedMode}
              toggleSitePlanningCommentUI={this.toggleSitePlanningCommentUI}
              editPlanningPolygon={this.editPlanningPolygon}
              toggleShowPlanningPolygons={this.toggleShowPlanningPolygons}
            />
          </Row>
        </Container>
        {isShowPolygonInfoModal && (
          <PolygonInfoModal
            initialIsOpen={isShowPolygonInfoModal}
            geoJson={drawingGeoJson || planningPolygonToEdit}
            onPolygonSaved={() => this.onPolygonSaved()}
            planningPolygonToEdit={planningPolygonToEdit}
            onCancelled={() => this.setState({ isShowPolygonInfoModal: false })}
          />
        )}
        {isShowCommentPopup && (
          <PolygonCommentModal
            initialIsOpen={isShowCommentPopup}
            planningPolygonToShowComment={planningPolygonToShowComment}
            onCancelled={() => this.setState({ isShowCommentPopup: false })}
          />
        )}
      </div>
    );
  }
}

export default SitePlanningMap;
